var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiCreative = function SvgAiCreative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.264 8.194 1.135-2.504 2.499-1.138-2.499-1.138L17.263.91l-1.135 2.504-2.499 1.138 2.499 1.138zm-6.815.455L8.178 3.642 5.906 8.649.909 10.925l4.997 2.276 2.272 5.008 2.271-5.008 4.997-2.276zM17.29 13.81v8.88h3.945v-4.883H26v-3.996z"
  })));
};
export default SvgAiCreative;